import {
  I2cInput, I2cCheckboxGroup,
  I2cListItem, I2cRadioGroup, I2cRadio,
  I2cCheckbox, I2cRadioButton, I2cFileUpload
} from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect, useRef, useState } from "react";
import "../../PrepaidComponents/Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { userCreationInfo, profileVerification } from "./stringUtils";
import { validationSchema } from "./ValidationSchema";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
import { useMutation } from "react-query";
import FilesUploadService from "../../../Services/FilesUploadService";

const UserCreation = ({
  type,
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const Manual = useRef();
  const [fileJson, setFileJson] = useState([]);
  const appSelectionForProgram = addFormData[1]?.["1_0"]?.app_selection_for_program || [];
  const state = type === "credit" ? "4_2" : "5_2";
  const handleCreationInfoCheckboxChange = (event) => {
    let SelectedNetworkValue;
    SelectedNetworkValue = event;
    let updatedSelectedNetworks = [
      ...(methods.getValues("additional_info_for_user_creation") ?? []),
    ];
    if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
      updatedSelectedNetworks = updatedSelectedNetworks.filter(
        (card) => card !== SelectedNetworkValue,
      );
    } else {
      updatedSelectedNetworks.push(SelectedNetworkValue);
    }
    methods.setValue("additional_info_for_user_creation", updatedSelectedNetworks);
    methods.trigger();
    handleValueChanges();
  };
  const handleProfileVerficationCheckboxChange = (event) => {
    let SelectedNetworkValue;
    SelectedNetworkValue = event;
    let updatedSelectedNetworks = [
      ...(methods.getValues("additional_authentication_channel_for_user_creation_Profile_Verification") ?? []),
    ];
    if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
      // If the card is already selected, remove it
      updatedSelectedNetworks = updatedSelectedNetworks.filter(
        (card) => card !== SelectedNetworkValue,
      );
    } else {
      updatedSelectedNetworks.push(SelectedNetworkValue);
    }
    methods.setValue("additional_authentication_channel_for_user_creation_Profile_Verification", updatedSelectedNetworks);
    methods.trigger();
    handleValueChanges();
  };
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    // reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    // criteriaMode: "all",
    criteriaMode: "firstError",
    defaultValues: {
      additional_customer_email_as_user_id: "No",
      additional_email_id_on_screen: "Yes",
      additional_info_for_user_creation: [],
      additional_authentication_channel_for_user_creation: "OTP",
      additional_authentication_channel_for_user_creation_OTP: "",
      additional_authentication_channel_for_user_creation_Profile_Verification: [],
      additional_support_additional_authentications: "No",
      additional_support_additional_authentications_details: "",
      additional_provide_agreement_for_customer_acceptance: "Yes",
      additional_agreement_type_for_toggle_control: "Accept Electronic Communication",
      additional_agreement_content_type: "Use Customized Content",
      additional_agreement_content_type_external_url: "",
      additional_agreement_content_type_customized_file: []
    },
  });

  const fields = [
    "additional_customer_email_as_user_id",
    "additional_email_id_on_screen",
    "additional_info_for_user_creation",
    "additional_provide_agreement_for_customer_acceptance",
    "additional_authentication_channel_for_user_creation",
    "additional_authentication_channel_for_user_creation_OTP",
    "additional_authentication_channel_for_user_creation_Profile_Verification",
    "additional_support_additional_authentications",
    "additional_support_additional_authentications_details",
    "additional_provide_agreement_for_customer_acceptance",
    "additional_agreement_type_for_toggle_control",
    "additional_agreement_content_type",
    "additional_agreement_content_type_external_url",
    "additional_agreement_content_type_customized_file"
  ];

  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      if (type === "credit") {
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[4]["4_2"][field] ?? "");
        });
      }
      else {
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[5]["5_2"][field] ?? "");
        });
      }
      setFileJson(state);
      methods.trigger();
    }
  }, [isFetching]);

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);
  const formData = new FormData();
  const handleFileUpload = async (name) => {
    try {
      formData.append("file", Manual.current.fileUpload.files[0]);
      await fileUpload.mutate(formData);
    } catch (error) {
      console.log(error);
    } finally {
      methods.trigger();
    }
  };
  const fileUpload = useMutation({
    mutationFn: async (formData) => {
      // setFormValidStates(state, false);
      return await FilesUploadService.uploadFile(formData);
    },
    onSuccess: (data) => {
      methods.setValue("additional_agreement_content_type_customized_file", data?.data?.url);
      methods.trigger();

      handleValueChanges();
    },
    onError: (e) => {
      console.log("api error");
    },
  });
  const handleValueChanges = () => {
    const values = methods.getValues();
    if (type === "credit") {
      setAddFormData({
        ...addFormData,
        4: {
          ...addFormData["4"],
          "4_2": { ...values },
        },
      });
    }
    else {
      setAddFormData({
        ...addFormData,
        5: {
          ...addFormData["5"],
          "5_2": { ...values },
        },
      });
    }
  };
  console.log("error in user creation", errors);
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (type === "credit") {
      if (errorsLength === 0) setFormValidStates("4_2", true);
      else setFormValidStates("4_2", false);
    }
    else {
      if (errorsLength === 0) setFormValidStates("5_2", true);
      else setFormValidStates("5_2", false);
    }
    handleValueChanges();
  }, [Object.keys(errors).length]);


  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  User Creation
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
            <div className="custom-label">
              This section is required if the client did not select the “Consumer” product, or if they selected “No” for user creation during consumer enrollment.
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="additional_customer_email_as_user_id"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Do you want to use the customer’s Email ID as the user ID? "
                    {...field}
                    name="additional_customer_email_as_user_id"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No"].map((bc, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("additional_customer_email_as_user_id") === bc
                        }
                        value={bc}
                      >
                        {bc}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.additional_customer_email_as_user_id &&
                    methods.formState.touchedFields.additional_customer_email_as_user_id
                    ? true
                    : false
                }
                message={errors.additional_customer_email_as_user_id?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {
            methods.watch("additional_customer_email_as_user_id") === "No" && (

              <div i2c-grid="12">
                <div className="single-field-wrapper">
                  <Controller
                    name="additional_email_id_on_screen"
                    control={control}
                    render={({ field }) => (
                      <I2cRadioGroup
                        label="Do you want to show the Email ID field on the screen?"
                        {...field}
                        name="additional_email_id_on_screen"
                        onI2cChange={(e) => {
                          field.onChange(e);
                          methods.trigger();
                          handleValueChanges();
                        }}
                      >
                        {["Yes", "No"].map((bc, index) => (
                          <I2cRadioButton
                            key={index}
                            checked={
                              methods.watch("additional_email_id_on_screen") === bc
                            }
                            value={bc}
                          >
                            {bc}
                          </I2cRadioButton>
                        ))}
                      </I2cRadioGroup>
                    )}
                  />
                  <ErrorMessage
                    show={
                      errors.additional_email_id_on_screen &&
                        methods.formState.touchedFields.additional_email_id_on_screen
                        ? true
                        : false
                    }
                    message={errors.additional_email_id_on_screen?.message ?? "Invalid input"}
                  />
                </div>
              </div>
            )}
          <div i2c-grid="12">
            <div className="custom-label mb-8">
              Please specify the information a cardholder must provide for user creation:
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="additional_info_for_user_creation"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup
                      {...field}
                      className="centeredCheckbox checkbox-margin"
                    >
                      <div i2c-grid="grid gap-sm">
                        {userCreationInfo.map((card, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="4@md"
                            variant="receipt"
                            label={card}
                            sublabel=""
                            value=""
                            type="checkbox"
                            checked={methods
                              .watch("additional_info_for_user_creation")
                              .includes(card)}
                            onI2cCheckboxClicked={(e) => {
                              handleCreationInfoCheckboxChange(card);
                            }}
                          >

                            <I2cCheckbox
                              slot="checkbox"
                              name="additional_info_for_user_creation"
                              filled
                              value={card}
                              label=""
                              ignoreTab
                              checked={methods
                                .watch("additional_info_for_user_creation")
                                .includes(card)}
                              className="customCheckbox"
                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.additional_info_for_user_creation &&
                          methods.formState.touchedFields.additional_info_for_user_creation
                          ? true
                          : false
                      }
                      message={
                        errors.additional_info_for_user_creation?.message ?? "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
          </div>
          <div i2c-grid="12">
            <div className="custom-label mb-8">
              Please select the additional authentication channel if you want to support that for this module.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="additional_authentication_channel_for_user_creation"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    onI2cChange={(e) => {
                      methods.setValue("additional_authentication_channel_for_user_creation", e.target.value);
                      if(e.target.value === "OTP"){
                        methods.setValue("additional_authentication_channel_for_user_creation_Profile_Verification",[])
                      }
                      else if(e.target.value === "Secret Question"){
                        methods.setValue("additional_authentication_channel_for_user_creation_OTP","")
                        methods.setValue("additional_authentication_channel_for_user_creation_Profile_Verification",[])
                      }
                      else{
                        methods.setValue("additional_authentication_channel_for_user_creation_OTP","")
                       
                      }
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {["OTP", "Secret Question", "Profile Verification"].map((cpi, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          label={cpi}
                          sublabel=""
                          value=""
                          checked={methods.watch("additional_authentication_channel_for_user_creation") === cpi}
                          type="checkbox"
                        >
                          <I2cRadio
                            slot="prefix"
                            name="credit_programType"
                            value={cpi}
                            filled
                            label=""
                            checked={
                              methods.watch("additional_authentication_channel_for_user_creation") === cpi
                            }
                          />
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {
            methods.watch("additional_authentication_channel_for_user_creation") === "OTP" && (
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  Please select the additional authentication channel if you want to support that for this module.
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="additional_authentication_channel_for_user_creation_OTP"
                    control={control}
                    render={({ field }) => (
                      <I2cRadioGroup
                        onI2cChange={(e) => {
                          methods.setValue("additional_authentication_channel_for_user_creation_OTP", e.target.value);
                          methods.trigger();
                          handleValueChanges();
                        }}
                      >
                        <div i2c-grid="grid gap-sm">
                          {["Email", "SMS", "Both"].map((cpi, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="4@md"
                              variant="receipt"
                              label={cpi}
                              sublabel=""
                              value=""
                              checked={methods.watch("additional_authentication_channel_for_user_creation_OTP") === cpi}
                              type="checkbox"
                            >
                              <I2cRadio
                                slot="prefix"
                                name="credit_programType"
                                value={cpi}
                                filled
                                label=""
                                checked={
                                  methods.watch("additional_authentication_channel_for_user_creation_OTP") === cpi
                                }
                              />
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cRadioGroup>
                    )}
                  />
                </div>
              </div>
            )
          }
          {
            methods.watch("additional_authentication_channel_for_user_creation") === "Profile Verification" && (
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  Please selects the fields to verify if you opted for Profile Verification method above.
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="additional_authentication_channel_for_user_creation_Profile_Verification"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {profileVerification.map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="4@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("additional_authentication_channel_for_user_creation_Profile_Verification")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleProfileVerficationCheckboxChange(card);
                                }}
                              >

                                <I2cCheckbox
                                  slot="checkbox"
                                  name="additional_authentication_channel_for_user_creation_Profile_Verification"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("additional_authentication_channel_for_user_creation_Profile_Verification")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.additional_authentication_channel_for_user_creation_Profile_Verification &&
                              methods.formState.touchedFields.additional_authentication_channel_for_user_creation_Profile_Verification
                              ? true
                              : false
                          }
                          message={
                            errors.additional_authentication_channel_for_user_creation_Profile_Verification?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
            )
          }
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="additional_support_additional_authentications"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Do you want to support Additional Authentication for this feature?"
                    {...field}
                    name="additional_support_additional_authentications"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      if(e.target.value === "No"){
                        methods.setValue("additional_support_additional_authentications_details","")
                      }
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No"].map((bc, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("additional_support_additional_authentications") === bc
                        }
                        value={bc}
                      >
                        {bc}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.additional_support_additional_authentications &&
                    methods.formState.touchedFields.additional_support_additional_authentications
                    ? true
                    : false
                }
                message={errors.additional_support_additional_authentications?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {
            methods.watch("additional_support_additional_authentications") === "Yes" && (
              <div i2c-grid="12 6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="additional_support_additional_authentications_details"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        label="Additional details for additional authentication"
                        placeholder="Enter details"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        name={"additional_support_additional_authentications_details"}

                      >
                      </I2cInput>
                    )}
                  />
                </div>
              </div>
            )
          }

          <div i2c-grid="12 12@md">
            <div className="custom-label mb-8">
              Provide agreements for customer acceptance?<sup>⦁</sup>
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="additional_provide_agreement_for_customer_acceptance"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label=""
                    {...field}
                    name="additional_provide_agreement_for_customer_acceptance"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      if(e.target.value === "No"){
                        methods.setValue("additional_agreement_type_for_toggle_control","")
                        methods.setValue("additional_agreement_content_type","")
                        methods.setValue("additional_agreement_content_type_customized_file","")
                      }
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No"].map((data, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("additional_provide_agreement_for_customer_acceptance") === data
                        }
                        value={data}
                      >
                        {data}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.additional_provide_agreement_for_customer_acceptance &&
                    methods.formState.touchedFields.additional_provide_agreement_for_customer_acceptance
                    ? true
                    : false
                }
                message={errors.additional_provide_agreement_for_customer_acceptance?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {
            methods.watch("additional_provide_agreement_for_customer_acceptance") === "Yes" && (
              <>
                <div i2c-grid="12 12@md">
                  <div className="custom-label-light mb-1-5">
                    The customer will indicate their acceptance by enabling a common toggle control. Please select the agreement types that should be linked to this common toggle control.
                  </div>
                  <div className="single-field-wrapper">
                    <Controller
                      name="additional_agreement_type_for_toggle_control"
                      control={control}
                      render={({ field }) => (
                        <I2cRadioGroup
                          onI2cChange={(e) => {
                            methods.setValue("additional_agreement_type_for_toggle_control", e.target.value);
                            methods.trigger();
                            handleValueChanges();
                          }}
                        >
                          <div i2c-grid="grid gap-sm">
                            {["Accept Electronic Communication", "Terms & Conditions", "Both"].map((cpi, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="4@md"
                                variant="receipt"
                                label={cpi}
                                sublabel=""
                                value=""
                                checked={methods.watch("additional_agreement_type_for_toggle_control") === cpi}
                                type="checkbox"
                              >
                                <I2cRadio
                                  slot="prefix"
                                  name="credit_programType"
                                  value={cpi}
                                  filled
                                  label=""
                                  checked={
                                    methods.watch("additional_agreement_type_for_toggle_control") === cpi
                                  }
                                />
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cRadioGroup>
                      )}
                    />
                  </div>
                </div>
                <div i2c-grid="12 12@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="additional_agreement_content_type"
                      control={control}
                      render={({ field }) => (
                        <I2cRadioGroup
                          label="Please specify the following for agreements."
                          {...field}
                          name="additional_agreement_content_type"
                          onI2cChange={(e) => {
                            field.onChange(e);
                            if(e.target.value === "Use Customized Content"){
                              methods.setValue("additional_agreement_content_type_external_url","")
                            }else{
                              methods.setValue("additional_agreement_content_type_customized_file",[])
                            }
                            methods.trigger();
                            handleValueChanges();
                          }}
                        >
                          {["Use Customized Content", "Use External URL"].map((data, index) => (
                            <I2cRadioButton
                              key={index}
                              checked={
                                methods.watch("additional_agreement_content_type") === data
                              }
                              value={data}
                            >
                              {data}
                            </I2cRadioButton>
                          ))}
                        </I2cRadioGroup>
                      )}
                    />
                    <ErrorMessage
                      show={
                        errors.additional_agreement_content_type &&
                          methods.formState.touchedFields.additional_agreement_content_type
                          ? true
                          : false
                      }
                      message={errors.additional_agreement_content_type?.message ?? "Invalid input"}
                    />
                  </div>
                </div>
                {
                  methods.watch("additional_agreement_content_type") === "Use Customized Content" ? (
                    <>
                      <div i2c-grid="12 12@md">
                        <div className="custom-label-light mb-1-5">
                          Content File(s)
                        </div>
                        <Controller
                          name="additional_agreement_content_type_customized_file"
                          control={control}
                          render={({ field }) => (
                            <I2cFileUpload
                              ref={Manual}
                              // max-file-size="0.439453125"
                              autoProcessQueue={false}
                              no-mobile-controls
                              className="customFileUpload"
                              setAcceptedFiles=".svg, .ai, .pdf,.eps"
                              icon="linear-document-upload"
                              label="Click to upload"
                              caption="or drag and drop"
                              name="additional_agreement_content_type_customized_file"
                              message="Format must be SVG, AI, PDF or ESP Format."
                              onI2cFileRemoved={(e) => {
                                if (
                                  fileJson?.additional_agreement_content_type_customized_file?.length
                                )
                                  methods.setValue(
                                    "additional_agreement_content_type_customized_file",
                                    fileJson?.additional_agreement_content_type_customized_file,
                                  );
                                else methods.setValue("additional_agreement_content_type_customized_file", []);
                                methods.trigger();
                                handleValueChanges();
                              }}
                              onI2cAddedFile={(e) => {
                                handleFileUpload(
                                  Manual.current.getDropZone().files[Manual.current.getDropZone().files.length - 1]
                                  
                                );
                              }}
                            />
                          )}
                        />
                      </div>
                    </>
                  ) : <>
                    <div i2c-grid="12 6@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="additional_agreement_content_type_external_url"
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              className="single-input-field"
                              placeholder="www.i2cinc.com"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                handleValueChanges();
                              }}
                              size="large"
                              name={"additional_agreement_content_type_external_url"}
                              prefix_label="http://"
                            >
                              <span slot="label" className="organize-tooltip">
                                <span className="custom-label">
                                  {" "}
                                  External Link
                                </span>
                              </span>
                            </I2cInput>
                          )}
                        />
                      </div>
                    </div>
                  </>
                }
              </>
            )
          }
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserCreation;
